<script>
export default {
  name: 'IconFpFood',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3 2.5v6c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2v-6" :stroke="color" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M6 2.5v19" :stroke="color" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M18 2.5c-1.7 0-3 1.8-3 4.5s1.3 4.5 3 4.5" :stroke="color" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M18 2.5v19" :stroke="color" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
